import { Navigate } from "react-router-dom";

export default function Extensions() {
  return <Navigate to="/shop?category=Hair%20Extensions" replace />;
}
